import { UserApi } from '@/api/user'


const state = () => ({
    users: [],
    usersPaginatedData: {},
    user: null,
    isLoading: false,
    isUpdating: false,
    updatedData: null,
    isSuccess: true,
    message: '',
    savedUserId: 0,
    current: 0,
    userReport: [],
    userSearch: [],
    loadingUserSearch: false,
    userSearchPagination: {},
})

const getters = {
    userList: state => state.users,
    usersPaginatedData: state => state.usersPaginatedData,
    user: state => state.user,
    isLoading: state => state.isLoading,
    isUpdating: state => state.isUpdating,
    updatedData: state => state.updatedData,
    isSuccess: state => state.isSuccess,
    message: state => state.message,
    savedUserId: state => state.savedUserId,
    current: state => state.current,
    userReport: state => state.userReport,
    userSearch: state => state.userSearch,
    loadingUserSearch: state => state.loadingUserSearch,
    userSearchPagination: state => state.userSearchPagination
}

const actions = {
    async fetchAllUsers({ commit }, query = null) {
        let page = 1
        let perPage = 10
        let search = ''
        if (query !== null) {
            page = query.page
            perPage = query.perPage
            search = query.search
        }
        commit('setUserIsLoading', true)
        await UserApi.getAll(perPage, page, search)
            .then(response => {
                commit('setUsers', response.data.data)
                const pagination = {
                    total: response.data.pages.total,
                    perPage: response.data.pages.per_page,
                    page: response.data.pages.current_page,
                    from: response.data.pages.from,
                }
                commit('setUsersPaginated', pagination)
                commit('setUserIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setUserIsLoading', false)
            })
    },
    async fetchDetailUser({ commit }, id) {
        commit('setUserIsLoading', true)
        commit('setSavedUserId', id)
        await UserApi.detail(id)
            .then(response => {
                // console.log(response)
                commit('setUserDetail', response.data.data)
                commit('setUserIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setUserIsLoading', false)
            })
    },
    async updateUser({ commit }, user) {
        commit('setUserIsUpdating', true)
        await UserApi.updateUser(user.id, user.data)
            .then(response => {
                // console.log(response)
                commit('saveUpdatedUser', response.data.data)
                commit('setUserIsUpdating', false)
            })
            .catch(error => {
                console.log(error)
                commit('setUserIsUpdating', false)
            })
    },
    async addMentor({ commit }, payload) {
        await UserApi.addMentor(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccess', true)
                    commit('setMessage', 'Berhasil Menambahkan Mentor')
                } else {
                    commit('setSuccess', false)
                    commit('setMessage', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccess', false)
                commit('setMessage', error.errors[0].message)
            })
    },
    async fetchUserReport({ commit }, query) {
        let startDate = null
        let endDate = null

        if (query) {
            startDate = query.startDate
            endDate = query.endDate
        }

        await UserApi.getUserReport(startDate, endDate)
            .then(res => {
                commit('setUserReport', res.data.data)
            })
            .catch(error => {
                commit('setSuccess', false)
                commit('setMessage', error.errors[0].message)
            })
    },
    async searchListUser({ commit }, query) {
        commit('setLoadingUserSearch', true)
        await UserApi.searchListUser(query)
            .then(res => {
                commit('setUserSearch', res.data.data)
                commit('setLoadingUserSearch', false)
                commit('setUserSearchPagination', res.data.pages)
            })
            .catch(err => {
                console.log(err)
                commit('setLoadingUserSearch', false)
                commit('setMessage', err)
            })
    },
    updateUserList({commit}, data) {
        commit('setUserIsLoading', true)
        commit('setUsers', data)
        commit('setUserIsLoading', false)
    }
}

const mutations = {
    setUsers: (state, users) => {
        state.users = users
    },

    setUsersPaginated: (state, usersPaginatedData) => {
        state.usersPaginatedData = usersPaginatedData
    },

    setSavedUserId: (state, savedUserId) => {
        state.savedUserId = savedUserId
    },
    setCurrentPage: (state, current) => {
        state.current = current
    },

    setUserDetail: (state, user) => {
        state.user = user
    },

    setUserDetailInput: (state, e) => {
        let user = state.user;
        user[e.target.name] = e.target.value;
        state.user = user
    },

    saveUpdatedUser: (state, user) => {
        state.users.unshift(user)
        state.updatedData = user
    },

    setUserIsLoading: (state, isLoading) => {
        state.isLoading = isLoading
    },

    setUserIsUpdating: (state, isUpdating) => {
        state.isUpdating = isUpdating
    },

    setSuccess: (state, isSuccess) => {
        state.isSuccess = isSuccess
    },

    setMessage: (state, message) => {
        state.message = message
    },

    setUserReport: (state, data) => {
        state.userReport = data
    },
    setUserSearch: (state, user) => {
        state.userSearch = user
    },
    setLoadingUserSearch: (state, loading) => {
        state.loadingUserSearch = loading
    },
    setUserSearchPagination: (state, pagination) => {
        state.userSearchPagination = pagination
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}